<template>
  <div class="text-gray-600 terms-of-use-component">
    <div class="lg:flex">
      <p class="terms-of-use-component-subject-title ota-subtitle pb-12 pr-10 lg:pt-4" v-html="$t('TermsOfUse.General.Subjects')" />
      <div class="mb-10 flex-1 flex justify-end">
        <div class="right-flex w-full">
          <ProductAccordion
            v-for="(contentBlock, index) in content"
            :key="`${contentBlock.Title}-${index}`"
            class="mt-5 border-b"
          >
            <template v-slot:trigger>
              {{ contentBlock.Title }}
            </template>
            <template v-slot:content>
              <div class="ota-small-light pb-5 md:pb-10" v-html="contentBlock.Content" />
            </template>
          </ProductAccordion>
        </div>
      </div>
    </div>
    <p class="text-right ota-small pb-10" v-text="$t('TermsOfUse.Content.LastEdited')" />
  </div>
</template>

<script>
import ProductAccordion from '@/components/Webshop/ProductAccordion'

export default {
  name: 'TermsOfUseComponent', // name clash
  components: {
    ProductAccordion
  },
  computed: {
    content () {
      return [...Array(this.$t('TermsOfUse.Content.Topics').length)].map((_, index) => ({
        Title: this.$t(`TermsOfUse.Content.Topics[${index}].Title`),
        Content: this.$t(`TermsOfUse.Content.Topics[${index}].Content`, {
          adjustDataLink: `<a href="${this.$t('FooterLinks.FaqAdjustData')}">${this.$t('TermsOfUse.General.Here')}</a>`
        })
      }))
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
